import request from "@/utils/requestSC";

// 积分列表
export async function getMyPointsList(params) {
  return request.post("/rest/points/getMyPointsList", params);
}
// 积分记录
export async function getMyPointsRecord(params) {
  return request.post("/rest/points/getMyPointsRecord", params);
}

// 发放转赠积分接口
export async function addGivePoints(params) {
  return request.post("/rest/points/addGivePoints", params);
}

// 获取转赠积分接口
export async function getGivePoints(params) {
  return request.post("/rest/points/getGivePoints", params);
}

// 领取转赠积分接口
export async function fetchGiveReq(params) {
  return request.post("/rest/points/fetchGiveReq", params);
}

// 积分规则
export async function getPointsRule(params) {
  return request.post("/rest/points/rule/getPointsRule", params);
}
